new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  watch: {
    menuFilter(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
    listOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
})

$(document).ready(function () {
  var bannerCategoryNew = $('.categories-banners');

  var bannerConfig = {
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    mobileFirst: true,
    adaptiveHeight: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    slidesToShow: 1,
    speed: 1500,
    cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
  }

  // Init banner
  function initBannerHome(el) {
    el.slick(bannerConfig);
  }

  const bannerNewCategory = document.querySelector('.categories-banners');
    if(bannerNewCategory) {
        let bannerImg = document.querySelector('.product-list__banner--figure img');
        if(bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerNewCategory.style.height = sizeBanner + 'px';
        }
    }  

  bannerCategoryNew.on('init', function (event, slick) {
    $('.banner-home').find('.banner-home__loading').hide();
    $('.slider-slick').css({
      visibility: 'visible',
      opacity: '1'
    });
  });

  $('.full-banner-new-category__description').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  })

  $('#js-carrousel-instagram').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 2,
    vertical: false,
    slidesToScroll: 2,
    slidesPerRow: 1,
    rows: 2,
    speed: 2000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          slidesPerRow: 1,
          rows: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesPerRow: 1,
          rows: 1
        }
      },
    ]
  });

  initBannerHome(bannerCategoryNew);

  $('.product_list').slick({
    arrows: false,
    dots: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,

    responsive: [
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 4,
        }
      }
    ]
  });

  function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#686868', '#000000', controlSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromSlider.value = from;
    }
  }

  function controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#686868', '#000000', controlSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
    }
  }

  function controlFromSlider(fromSlider, toSlider, fromInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#686868', '#000000', toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromInput.value = from;
    }
  }

  function controlToSlider(fromSlider, toSlider, toInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#686868', '#000000', toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
    }
  }

  function getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }

  function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to ? to.max - to.min : 0;
    const fromPosition = from ? from.value - to.min : 0;
    const toPosition = to ? to.value - to.min : 0;
    if(controlSlider) {
      controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
    }
  }

  function setToggleAccessible(currentTarget) {
    const toSlider = document.querySelector('#toSlider');
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }

  const fromSlider = document.querySelector('#fromSlider');
  const toSlider = document.querySelector('#toSlider');
  const fromInput = document.querySelector('#fromInput');
  const toInput = document.querySelector('#toInput');

  if(fromSlider, toSlider, fromInput, toInput) {
    let url = window.location.href;
    if (url.includes('?lp=')) {
      const params = new URLSearchParams(window.location.search)
      const firstParams = params.get('lp');
      const secondParams = params.get('hp');
      fromInput.value = firstParams;
      toInput.value = secondParams;
      fromSlider.setAttribute('value', firstParams);
      toSlider.setAttribute('value', secondParams);
      fillSlider(fromSlider, toSlider, '#686868', '#000000', toSlider);
    } else {
      fillSlider(fromSlider, toSlider, '#686868', '#000000', toSlider);
      setToggleAccessible(toSlider);
    }
  
    fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
    toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
    fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
    toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);
    $(fromSlider).mouseup(function () {
      let from = $('#fromInput').val()
      let to = $('#toInput').val()
      window.location = `?lp=${from}&hp=${to}`
    })
    $(toSlider).mouseup(function () {
      let from = $('#fromInput').val();
      let to = $('#toInput').val()
      window.location = `?lp=${from}&hp=${to}`
    })
  
    const ordenation = document.querySelector('#ordenacao')
    ordenation[0].innerText = "Ordenar"
  }
})